'use client';

import React from 'react';

interface DropdownEmptyStateProps {
  hasResults: boolean;
  isLoading: boolean;
  searchTerm: string;
  emptyMessage: string;
}

const DropdownEmptyState: React.FC<DropdownEmptyStateProps> = ({
  hasResults,
  isLoading,
  searchTerm,
  emptyMessage,
}): React.ReactElement | null => {
  if (hasResults) return null;

  if (isLoading) {
    return (
      <div className="px-3 py-2 text-center text-neutral-500 text-sm">
        Loading...
      </div>
    );
  }

  return (
    <div className="px-3 py-4 text-center text-neutral-500 text-sm flex justify-center items-center">
      {searchTerm
        ? `No ${emptyMessage} found for "${searchTerm}"`
        : `No ${emptyMessage} found`}
    </div>
  );
};

export default DropdownEmptyState;
